// /home/Hakyury/sites/eight-percent.com/frontend/src/component/Home.jsx
import React, { useEffect, useState, useRef } from 'react';

const sites = [
  {
    id: 1,
    name: "Campfire",
    description: "Геймерское сообщество с рейтингами и соревнованиями",
    url: "#",
    status: "dev",
    icon: "🔥",
    color: "from-gray-700/20 to-gray-800/10",
    hoverColor: "from-orange-500/20 to-red-500/10",
    glow: "shadow-[0_0_30px_rgba(251,146,60,0)]",
    hoverGlow: "shadow-[0_0_30px_rgba(251,146,60,0.15)]"
  },
  {
    id: 2,
    name: "Étoile",
    description: "Сервис для поиска знакомств и общения",
    url: "#",
    status: "dev",
    icon: "✨",
    color: "from-gray-700/20 to-gray-800/10",
    hoverColor: "from-purple-500/20 to-pink-500/10",
    glow: "shadow-[0_0_30px_rgba(192,132,252,0)]",
    hoverGlow: "shadow-[0_0_30px_rgba(192,132,252,0.15)]"
  },
  {
    id: 3,
    name: "FrameParty",
    description: "Платформа для совместного просмотра фильмов",
    url: "#",
    status: "dev",
    icon: "🎬",
    color: "from-gray-700/20 to-gray-800/10",
    hoverColor: "from-blue-500/20 to-cyan-500/10",
    glow: "shadow-[0_0_30px_rgba(56,189,248,0)]",
    hoverGlow: "shadow-[0_0_30px_rgba(56,189,248,0.15)]"
  }
];

// Компонент для анимированного текста с эффектом частиц
const AnimatedTitle = () => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [isMouseInCanvas, setIsMouseInCanvas] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    
    const setCanvasSize = () => {
      if (containerRef.current) {
        canvas.width = containerRef.current.offsetWidth;
        canvas.height = containerRef.current.offsetHeight;
      }
    };

    setCanvasSize();

    const particles = [];
    const particleCount = 200;

    // Инициализация частиц
    const initParticles = () => {
      particles.length = 0;
      for (let i = 0; i < particleCount; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          size: Math.random() * 2 + 0.5,
          speedX: (Math.random() - 0.5) * 0.5,
          speedY: (Math.random() - 0.5) * 0.5,
          color: `rgba(${Math.random() > 0.5 ? '147, 51, 234' : '56, 189, 248'}, ${Math.random() * 0.3 + 0.1})`,
          originalX: 0,
          originalY: 0,
        });
      }
    };

    initParticles();

    let animationId;

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(particle => {
        // Обновление позиции
        particle.x += particle.speedX;
        particle.y += particle.speedY;

        // Отскок от границ
        if (particle.x < 0 || particle.x > canvas.width) particle.speedX *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.speedY *= -1;

        // Притяжение к курсору только если мышь в пределах canvas
        if (isMouseInCanvas) {
          const dx = mousePos.x - particle.x;
          const dy = mousePos.y - particle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          
          if (distance < 150) {
            const force = 0.1 * (1 - distance / 150);
            particle.x += dx * force;
            particle.y += dy * force;
          }
        }

        // Рисование частицы
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fillStyle = particle.color;
        ctx.fill();

        // Соединение близких частиц
        particles.forEach(otherParticle => {
          const dx = particle.x - otherParticle.x;
          const dy = particle.y - otherParticle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 80) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(147, 51, 234, ${0.1 * (1 - distance / 80)})`;
            ctx.lineWidth = 0.5;
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(otherParticle.x, otherParticle.y);
            ctx.stroke();
          }
        });
      });

      animationId = requestAnimationFrame(animate);
    };

    animate();

    const handleResize = () => {
      setCanvasSize();
      initParticles();
    };

    const handleMouseMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      setMousePos({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      });
    };

    const handleMouseEnter = () => {
      setIsMouseInCanvas(true);
    };

    const handleMouseLeave = () => {
      setIsMouseInCanvas(false);
    };

    window.addEventListener('resize', handleResize);
    canvas.addEventListener('mousemove', handleMouseMove);
    canvas.addEventListener('mouseenter', handleMouseEnter);
    canvas.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', handleResize);
      canvas.removeEventListener('mousemove', handleMouseMove);
      canvas.removeEventListener('mouseenter', handleMouseEnter);
      canvas.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [mousePos, isMouseInCanvas]);

  return (
    <div ref={containerRef} className="relative h-96 w-full overflow-hidden rounded-2xl border border-white/10 backdrop-blur-sm">
      <canvas
        ref={canvasRef}
        className="absolute inset-0 h-full w-full"
      />
      
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <h1 className="relative z-10 text-center">
          <span className="block text-5xl md:text-7xl font-bold mb-4">
            <span className="bg-gradient-to-r from-purple-400 via-violet-300 to-cyan-300 bg-clip-text text-transparent animate-gradient">
              Eight Percent
            </span>
          </span>
          <span className="block text-xl md:text-2xl text-gray-300 font-light">
            Там, где тепло в пустоте
          </span>
        </h1>
      </div>
    </div>
  );
};

const SiteCard = ({ site }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`
        relative rounded-2xl p-8 transition-all duration-700
        bg-gradient-to-br ${isHovered ? site.hoverColor : site.color} backdrop-blur-sm
        border border-white/10
        ${isHovered ? site.hoverGlow : site.glow}
        hover:scale-[1.02] hover:-translate-y-1
        overflow-hidden group
        cursor-default
      `}
      style={{
        '--glow-color': site.hoverGlow.includes('orange') 
          ? 'rgba(251,146,60,0.2)' 
          : site.hoverGlow.includes('purple')
          ? 'rgba(192,132,252,0.2)'
          : 'rgba(56,189,248,0.2)'
      }}
    >
      {/* Фоновые туманности */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-transparent via-black/10 to-transparent"></div>
      
      {/* Космическая туманность при наведении */}
      <div className={`
        absolute inset-0 transition-all duration-700
        ${isHovered ? 'opacity-30' : 'opacity-0'}
      `}>
        <div className="absolute inset-0 bg-gradient-to-br from-current to-transparent mix-blend-soft-light"></div>
      </div>
      
      {/* Парящие частицы */}
      {Array.from({ length: 5 }).map((_, i) => (
        <div
          key={i}
          className={`absolute w-1 h-1 bg-white/20 rounded-full ${
            isHovered ? 'opacity-100' : 'opacity-0'
          } transition-opacity duration-700`}
          style={{
            left: `${15 + i * 20}%`,
            top: `${20 + i * 15}%`,
            animation: `float ${3 + i * 1.5}s infinite ease-in-out`,
          }}
        ></div>
      ))}
      
      {/* Контент */}
      <div className="relative z-10">
        <div className="flex items-start justify-between mb-6">
          <div className={`
            text-5xl transition-all duration-700
            ${isHovered ? 'scale-110 rotate-6' : 'opacity-60'}
          `}>
            {site.icon}
          </div>
          
          <span className={`
            px-4 py-1.5 rounded-full text-sm font-medium backdrop-blur-sm
            bg-white/10 text-gray-300 border border-white/20
            transition-all duration-300
            ${isHovered ? 'scale-105 bg-white/20 text-white' : ''}
          `}>
            В РАЗРАБОТКЕ
          </span>
        </div>
        
        <h3 className={`
          text-2xl font-bold mb-3 transition-colors duration-700
          ${isHovered ? 'text-white' : 'text-gray-300'}
        `}>
          {site.name}
        </h3>
        
        <p className="text-gray-400 mb-6 leading-relaxed">
          {site.description}
        </p>
        
        <div className="flex items-center">
          <div className={`
            relative w-3 h-3 rounded-full mr-3 transition-all duration-700
            ${isHovered ? 'bg-amber-400 scale-125' : 'bg-gray-500'}
          `}>
            <div className={`
              absolute inset-0 rounded-full animate-ping
              ${isHovered ? 'bg-amber-400' : 'bg-gray-500'}
            `}></div>
          </div>
          <span className="text-sm text-gray-400">
            В активной разработке
          </span>
        </div>
      </div>
      
      {/* Луч света при наведении */}
      <div className={`
        absolute -bottom-8 -left-8 right-0 h-16 bg-gradient-to-t from-current to-transparent
        opacity-0 group-hover:opacity-[0.03] transition-opacity duration-700
        rotate-180
      `}></div>
    </div>
  );
};

export default function Home() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Эффект звездного неба
  useEffect(() => {
    const createStars = () => {
      const container = document.getElementById('starfield');
      if (!container) return;
      
      container.innerHTML = '';
      
      for (let i = 0; i < 150; i++) {
        const star = document.createElement('div');
        star.className = 'star';
        star.style.cssText = `
          position: absolute;
          width: ${Math.random() * 2 + 0.5}px;
          height: ${Math.random() * 2 + 0.5}px;
          background: rgba(255, 255, 255, ${Math.random() * 0.5 + 0.1});
          border-radius: 50%;
          left: ${Math.random() * 100}%;
          top: ${Math.random() * 100}%;
          animation: twinkle ${Math.random() * 4 + 2}s infinite alternate;
          z-index: 0;
        `;
        container.appendChild(star);
      }
    };
    
    createStars();
    window.addEventListener('resize', createStars);
    return () => window.removeEventListener('resize', createStars);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-black to-gray-900 overflow-hidden">
      {/* Звездное небо */}
      <div id="starfield" className="fixed inset-0 pointer-events-none z-0"></div>
      
      {/* Туманности курсора */}
      <div 
        className="fixed pointer-events-none z-0 w-96 h-96 rounded-full blur-3xl opacity-10"
        style={{
          left: mousePosition.x - 192,
          top: mousePosition.y - 192,
          background: 'radial-gradient(circle, rgba(147,51,234,0.2) 0%, rgba(79,70,229,0.1) 30%, transparent 70%)',
          transition: 'left 0.3s ease-out, top 0.3s ease-out',
        }}
      ></div>



      {/* Герой-секция */}
      <section className="relative max-w-7xl mx-auto px-4 pt-32 pb-16 text-center z-10">
        {/* Туманности в фоне */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-96">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-600/10 via-transparent to-indigo-600/10 blur-3xl"></div>
          <div className="absolute top-0 left-1/4 w-64 h-64 bg-gradient-to-br from-purple-500/5 to-transparent rounded-full blur-2xl"></div>
          <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-gradient-to-tr from-indigo-500/5 to-transparent rounded-full blur-2xl"></div>
        </div>
        
        <div className="relative mb-16">
          {/* Анимированный заголовок */}
          <div className="mb-8">
            <AnimatedTitle />
          </div>
          

        </div>
      </section>
      
      {/* Секция проектов */}
      <section className="relative max-w-7xl mx-auto px-4 pb-32 z-10">
        {/* Сетка проектов */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {sites.map((site) => (
            <SiteCard key={site.id} site={site} />
          ))}
        </div>
      </section>
      
      {/* CSS анимации */}
      <style jsx>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.1; }
          50% { opacity: 0.6; }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          33% { transform: translateY(-5px) translateX(3px); }
          66% { transform: translateY(2px) translateX(-3px); }
        }
        
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes gradient {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out forwards;
        }
        
        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 3s ease infinite;
        }
        
        .star {
          position: absolute;
          background: white;
          border-radius: 50%;
          animation: twinkle var(--duration) infinite alternate;
        }
      `}</style>
    </div>
  );
}